<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>Customer - {{this.subTitle}}</h2>
			</b-col>
			<b-col lg="6">			
				<b-dropdown :disabled="edit" class="pull-right" right variant="info" no-caret>
					<template slot="button-content">
						<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="editTdg()">Edit</b-dropdown-item>
					<b-dropdown-item @click="deleteTdg()">Delete</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</div>

		<div>
			<b-card v-if="loadingData">
				<b-col cols="12" sm="12" md="12" lg="12">
					<p class="text-center">
						<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
					</p>
				</b-col>
			</b-card>
			<div v-else>
				<b-card v-if="found">
						<b-row>
							<b-col md="8">
                                <b-form-group :label-cols="4" id="L1" label="Customer Name" label-for="Tdg1" horizontal>
                                <b-form-input v-if="!edit" id="Tdg1" type="text" v-model="model.customer_name" class="plaintext-input" plaintext></b-form-input>
                                <b-form-input v-else id="Tdg1" type="text" v-model="model.customer_name"></b-form-input>
                                </b-form-group>
                                <b-form-group :label-cols="4" id="L2" label="Address 1" label-for="Tdg2" horizontal>
                                <b-form-input v-if="!edit" id="Tdg2" type="text" v-model="model.address_1" class="plaintext-input" plaintext></b-form-input>
                                <b-form-input v-else id="Tdg2" type="text" v-model="model.address_1" ></b-form-input>
                                </b-form-group>
                                <b-form-group :label-cols="4" id="L3" label="Address 2" label-for="Tdg3" horizontal>
                                <b-form-input v-if="!edit" id="Tdg3" type="text" v-model="model.address_2" class="plaintext-input" plaintext></b-form-input>
                                <b-form-input v-else id="Tdg3" type="text" v-model="model.address_2" ></b-form-input>
                                </b-form-group>
                                <b-form-group :label-cols="4" id="L4" label="Address 3" label-for="Tdg4" horizontal>
                                <b-form-input v-if="!edit" id="Tdg4" type="text" v-model="model.address_3" class="plaintext-input" plaintext></b-form-input>
                                <b-form-input v-else id="Tdg4" type="text" v-model="model.address_3" ></b-form-input>
                                </b-form-group>
                                <b-form-group :label-cols="4" id="L5" label="Postal Zip" label-for="Tdg5" horizontal>
                                <b-form-input v-if="!edit" id="Tdg5" type="text" v-model="model.postal_zip" class="plaintext-input" plaintext></b-form-input>
                                <b-form-input v-else id="Tdg5" type="text" v-model="model.postal_zip" ></b-form-input>
                                </b-form-group>
                                <b-form-group :label-cols="4" id="L6" label="Prov State" label-for="Tdg6" horizontal>
                                <b-form-input v-if="!edit" id="Tdg6" type="text" v-model="model.prov_state" class="plaintext-input" plaintext></b-form-input>
                                <b-form-input v-else id="Tdg6" type="text" v-model="model.prov_state" ></b-form-input>
                                </b-form-group>  
                                <b-form-group :label-cols="4" id="L7" horizontal label="Currency" label-for="Tdg7">
                                    <b-form-input v-if="!edit" id="Tdg6" type="text" v-model="model.currency_name" class="plaintext-input" plaintext></b-form-input>
                                    <b-form-select v-else :disabled="currency.length==0" value-field="id" text-field="name" id="Tdg7" v-model="model.currency_id" :options="currency">
                                    <template slot="first"><option :value="null" disabled>-- select currency --</option></template>
                                    </b-form-select>
                                </b-form-group> 
                                <b-form-group :label-cols="4" id="L8" horizontal label="GST" label-for="Tdg8">
                                    <b-form-checkbox v-if="!edit" 
                                        id="Tdg8"
                                        class="custom-checkboxes"
                                        style="margin-top: 43px;"
                                        v-model="model.gst"
										plain 
                                        disabled
                                    ></b-form-checkbox>	
                                    <b-form-checkbox v-else
                                        id="Tdg8"
                                        class="custom-checkboxes"
                                        style="margin-top: 43px;"
                                        v-model="model.gst"
										plain
										value=true 
                						unchecked-value=false
                                    ></b-form-checkbox>	
                                </b-form-group>        
                                <b-form-group :label-cols="4" id="L9" label="Day of Month " label-for="Tdg9" horizontal>
                                <b-form-input v-if="!edit" id="Tdg6" type="text" v-model="model.invoice_DoM_name" class="plaintext-input" plaintext></b-form-input>
                                <b-form-select v-else :disabled="DoM.length==0" value-field="id" text-field="name" id="Tdg9" v-model="model.invoice_DoM" :options="DoM">
                                <template slot="first"><option :value="null" disabled>-- select day of month(optional) --</option></template> 
                                </b-form-select>
                                </b-form-group>
                                <b-form-group :label-cols="4" id="L10" label="Placeholder 1" label-for="Tdg10" horizontal>
                                <b-form-input v-if="!edit" id="Tdg10" type="text" v-model="model.placeholder_1" class="plaintext-input" plaintext></b-form-input>
                                <b-form-input v-else id="Tdg10" type="text" v-model="model.placeholder_1" ></b-form-input>
                                </b-form-group>  
                                <b-form-group :label-cols="4" id="L11" label="Placeholder 2" label-for="Tdg11" horizontal>
                                <b-form-input v-if="!edit" id="Tdg11" type="text" v-model="model.placeholder_2" class="plaintext-input" plaintext></b-form-input>
                                <b-form-input v-else id="Tdg10" type="text" v-model="model.placeholder_1" ></b-form-input>
                                </b-form-group>
								
								<b-form-group v-if="!edit" :label-cols="4" id="L14" label="Infile" label-for="file" horizontal>
									<div v-for="(file_in, index) in model.infile">
										<p>{{file_in.name}}</p>   
									</div>
								</b-form-group>
								<b-form-group v-else :label-cols="4" id="L15" label="Attach File" label-for="file" horizontal>
									<b-table striped show-empty empty-text="No file have been added"
										:fields = "[{key: 'delete', label: ' '}, {key: 'name', label: ' '}]" 
										:items="model.infile" stacked="sm" outlined small>
										<template slot="delete" slot-scope="item">
											<b-btn v-b-tooltip.hover title="Delete" v-on:click="removefile(item.index)" size="sm" class="pull-right"><i class="icon-close"></i></b-btn>
										</template>
										<template slot="name" slot-scope="item">
											<span v-if="item.item.name==''" class="show-details-cell">
												<input type="file" class="form-control-file" id="files" ref="file" accept="application/pdf, image/png, image/jpg, .xlsx, .xls, .doc, docx" v-on:change="handleFileUpload(item.index)" />
              								</span>
											<span v-else>
												{{item.item.name}}
											</span>
										</template>
									</b-table>
									<b-row>
									<b-col sm="12">
										<b-btn  v-on:click="anotherfile()" size="sm" variant="primary" class="pull-right">Add another file</b-btn>
									</b-col>
									</b-row>				      
			      				</b-form-group>

								<div slot="footer" v-show="edit">
									<b-button @click="update()" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
									<b-button @click="editTdg()" size="sm"><i class="fa fa-ban"></i> Cancel</b-button>
								</div>
							</b-col>
						</b-row>
					<!-- </b-tab> -->
				</b-card>
				<b-row v-else>
					<b-col cols="12" sm="12" md="12" lg="12">
						<br>
						<p class="text-center text-danger">
							<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
						</p>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
	import invoice_service from './invoices_service'
	export default {
		name: 'InvoiceCostumer',
		created: function() {
			this.getCompanyData()
		},
		props: {
			id: {
				type: String,
				default: 0
			}
		},
		data() {
			return {
				subTitle        : '',
				edit            : false,
				found           : false,
				notFoundMessage : 'Not found',
                model       : {
                        customer_name       : '',
                        address_1           : '',
                        address_2           : '',
                        address_3           : '',
                        postal_zip          : '',
                        prov_state          : '',
                        currency_id         : null,
                        gst                 : false,
                        invoice_DoM         : null,
                        placeholder_1       : '',
                        placeholder_2       : '',
                        invoice_DoM_name    : '',
						infile              : [],

                    },
				updateData      : null,
				originalData    : null,
				loadingData     : true,
                currency        : [],
                        DoM         : [
        { 'id':1, 'name':'1'}, 
        { 'id':2, 'name':'2'},
        { 'id':3, 'name':'3'}, 
        { 'id':4, 'name':'4'},
        { 'id':5, 'name':'5'}, 
        { 'id':6, 'name':'6'},
        { 'id':7, 'name':'7'}, 
        { 'id':8, 'name':'8'},
        { 'id':9, 'name':'9'}, 
        { 'id':10, 'name':'10'},
        { 'id':11, 'name':'11'}, 
        { 'id':12, 'name':'12'},
        { 'id':13, 'name':'13'}, 
        { 'id':14, 'name':'14'},
        { 'id':15, 'name':'15'}, 
        { 'id':16, 'name':'16'},
        { 'id':17, 'name':'17'}, 
        { 'id':18, 'name':'18'},
        { 'id':19, 'name':'19'}, 
        { 'id':20, 'name':'20'},
        { 'id':21, 'name':'21'}, 
        { 'id':22, 'name':'22'},
        { 'id':23, 'name':'23'}, 
        { 'id':24, 'name':'24'},
        { 'id':25, 'name':'25'}, 
        { 'id':26, 'name':'26'},
        { 'id':27, 'name':'27'}, 
        { 'id':28, 'name':'28'},
        { 'id':29, 'name':'29'}, 
        { 'id':30, 'name':'30'},
        { 'id':31, 'name':'31'}, 
        ],
		file                  : '',
        infile : {
            'name': '',
            'file_64':'',
        },
        otherfile : {
            'name': '',
            'file_64':'',
        }
			}
		},
		methods: {
			editTdg() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
				} else {
					this.edit = true
				}
			},
			restoreOriginalData() {
				let model = {
					...this.originalData,
				}
				this.model = model
			},
			getCompanyData() {
				invoice_service.getBy_icustomer(this.id)
					.then(data => {
						if (data.status == 'success') {
							this.originalData   = data.invoice_customer
                            this.currency = data.currency
                            console.log(this.originalData)
                            //this.fluidtypeselect  = data.fluid_types					
							this.companyId      = this.id
							this.loadingData    = false
							this.found          = true
							this.restoreOriginalData()							
							this.subTitle       = this.companyId
						}else {
                            this.$swal(data.status, data.message, data.status)
                            this.loadingData = false
                            return

                        }
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			okToUpdate() {
				if (this.model.customer_name === undefined || this.model.customer_name.trim().length == 0) {
					this.$swal('Alert!', 'Customer Name can not be empty', 'warning')
					return false
				}
				if (this.model.currency_id === undefined || this.model.currency_id == null) {
					this.$swal('Alert!', 'Address can not be empty', 'warning')
					return false
				}
					return true
			},
            update () {
                if (!this.okToUpdate()) {
					return
				}
                console.log(this.model)
				invoice_service.update_icustomer(this.companyId, this.model)
					.then((data) => {
						this.$swal(data.status, data.message, data.status)
							.then((result) => {
								this.getCompanyData()
							})
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
					this.edit=false
			},
			deleteTdg() {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this Invoice Customer: " + this.model.customer_name+ " ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						invoice_service.delete_icustomer(this.companyId)
							.then(data => {
								this.$swal(data.status, data.message, data.status)
								if (data.status == 'success') {
									this.$router.replace('/invoice_customers')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
			handleFileUpload(index) {
				if (this.$refs.file.files.length>0) {

					this.file = this.$refs.file.files[0]
					this.infile.name = this.file.name//this.$refs.files.files[i].name
					
					let url = window.URL.createObjectURL(this.file)
					this.url = url
					setTimeout(() => window.URL.revokeObjectURL(url), 100)
					let reader = new FileReader()
					reader.readAsDataURL(this.file)             
					reader.onload = function() {
						localStorage.setItem('file_64', reader.result)      
						return
					}        
					this.infile.file_64 = localStorage.getItem('file_64')

					this.model.infile[index].name = this.infile.name
					this.model.infile[index].file_64 = this.infile.file_64
					console.log('-model-->',this.model.infile)  
				}
        	},
        	removefile(otherfile) {
				  this.model.infile.splice(otherfile,1)
			},
			anotherfile() {

				if (this.model.infile.length===0) {
					this.model.infile.push(this.otherfile)
					this.infile = {
						'name': '',
						'file_64':'',
					}
				} else {
					let file_in 		= this.model.infile
					let file_in_index 	= file_in.map(o => o.name).indexOf('')
					if (file_in_index > -1) {
						this.$swal('warning', 'File no selected', 'warning')

					} else {
						this.otherfile = {
							'name': '',
							'file_64':'',
						}
						this.model.infile.push(this.otherfile)
						this.infile = {
							'name': '',
							'file_64':'',
						}						
					}

				}

			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/invoices/invoice_customer.vue